import {useAppSelector} from "@Hooks/selector/useAppSelector";

export const useIsAircash = () => {
    const {
        companyStore,
    } = useAppSelector((state) => state?.page)

    return ['1001', '1003', '1004'].includes(companyStore.style.id?.toString());
}